import { useRef } from 'react';

export const useDepartmentsNavigation = () => {
  const ref = useRef<HTMLElement | null>(null);

  return { ref };
};
